import { FC } from 'react';

import { ITextParser } from './interface';
import {getMarkdown, stripHTML} from './utils.tsx';
import {renderToString} from "react-dom/server";

const TextParser: FC<ITextParser> = ({ text, option }) => {
  const components: FC[] = getMarkdown(text, option);
  if (!option?.removeHTML) {
    return <>{components}</>;
  }
  const renderList: string[] = components.map((component: FC) => renderToString(component));
  const renderString = renderList?.map(s => stripHTML(s)).join('\n');
  return (<>{renderString}</>);
};

export default TextParser;
